/**
 * Immer plugin bootstrap — side-effect-only module. Import it; it exports nothing.
 *
 * Immer drafts a `Set`/`Map` the moment one is READ off a draft, not when one is
 * written, and that read goes through a plugin that is NOT loaded by default:
 *
 *     set((s) => { if (s.recentEvents.set.has(id)) return; ... })
 *                    ^ throws "[Immer] minified error nr: 0" without enableMapSet()
 *
 * That threw on every inbox socket event in production (Sentry 7725688322) — as
 * an unhandled promise rejection, so no error boundary caught it and the UI kept
 * looking healthy while the event-dedup tape silently recorded nothing.
 *
 * Import this from `main.tsx` AND from every store that keeps a `Set`/`Map` in
 * state. The store-level import is the load-bearing one: inbox is a `lazy()`
 * route and vitest never runs `main.tsx`, so a bootstrap-only call would leave
 * both the code-split chunk and the test suite unprotected. Immer's `loadPlugin`
 * no-ops when the plugin is already registered, so importing it more than once
 * costs nothing.
 */
import { enableMapSet } from 'immer';

enableMapSet();
